import React, { FC } from "react";
import { Person } from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import { IdlocaGeneric } from "../../locales/IdlocaGeneric";
import { Box, Typography } from "@mui/material";

interface IUnAuthorizedUser {
    handleClickOpen: () => void;
}

export const UnAuthorizedUser: FC<IUnAuthorizedUser> = ({ handleClickOpen }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: theme => theme.palette.button.primary,
                color: theme => theme.palette.button.text,
                border: "1px solid rgba(0, 0, 0, 0.1)",
                borderRadius: "4px",
                padding: "3px 6px",
                height: 30,
                "&:hover": {
                    backgroundColor: theme => theme.palette.button.hover,
                },
                transition: "background-color 0.2s",
            }}
            onClick={handleClickOpen}
        >
            <Person
                fontSize="small"
                sx={{
                    marginRight: "8px",
                    color: theme => theme.palette.button.text,
                }}
            />
            <Typography
                variant="body2"
                sx={{
                    fontWeight: 500,
                    color: theme => theme.palette.button.text,
                }}
            >
                <Locale localeId={IdlocaGeneric.login} />
            </Typography>
        </Box>
    );
};
